import getTranslatedLabel from './get-tranlslated-label';
export function createNewDataSection(title, key, entries, translations) {
    return {
        title,
        key,
        entries: filterConditionalEntries(mapEntriesToTechSectionEntry(filterConditionalEntries(entries), translations)),
    };
}
export function filterConditionalEntries(entries) {
    return entries.filter(Boolean);
}
export function mapEntriesToTechSectionEntry(entries, translations) {
    const newEntries = entries.map((entry) => {
        var _a;
        const label = getTranslatedLabel(translations, entry.item.translationKey, entry.item.label);
        if (label) {
            const mappedEntry = {
                title: getTranslatedLabel(translations, entry.item.translationKey, entry.item.label),
                value: (_a = entry.item.formattedValue) !== null && _a !== void 0 ? _a : '',
                remarks: entry.item.remarks,
                key: entry.key,
            };
            return mappedEntry;
        }
        return null;
    });
    return newEntries;
}
